import { axiosApiInstance } from '@/api/axios'

const urlBase = '/api/public'

const state = {
  partners: [],
  singlePartner: {},
  partnersPageLoading: false
}

const getters = {
  partners: (state) => state.partners,
  singlePartner: (state) => state.singlePartner,
  partnersPageLoading: (state) => state.partnersPageLoading
}

const mutations = {
  setPartners(state, payload) {
    state.partners = payload
  },
  setSinglePartner(state, payload) {
    state.singlePartner = payload
  },
  setPartnersPageLoading(state, payload) {
    state.partnersPageLoading = payload
  }
}

const actions = {
  fetchPartners({ commit }) {
    commit('setPartnersPageLoading', true)
    axiosApiInstance
      .get(`${urlBase}/get_partners`)
      .then((res) => {
        console.log(res)
        commit('setPartners', res.data.data)
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setTimeout(() => {
          commit('setPartnersPageLoading', false)
        }, 500)
      })
  },

  fetchPartnersWithPagination({ commit }, { vm }) {
    commit('setPartnersPageLoading', true)
    axiosApiInstance
      .get(vm.urlForFetch)
      .then((res) => {
        vm.numberOfPages = res.data.last_page
        vm.partners = res.data.data
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setTimeout(() => {
          commit('setPartnersPageLoading', false)
        }, 500)
      })
  },

  fetchSinglePartner({ commit }, payload) {
    commit('setPartnersPageLoading', true)
    axiosApiInstance
      .get(`${urlBase}/get_single_partner`, {
        params: {
          id: payload
        }
      })
      .then((res) => {
        commit('setSinglePartner', res.data)
      })
      .catch((err) => console.log(err))
      .finally(() => {
        setTimeout(() => {
          commit('setPartnersPageLoading', false)
        }, 500)
      })
  },

  clearSinglePartner({ commit }) {
    commit('setSinglePartner', {})
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
